import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const PunctureWound = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex ?? 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'puncture-wound-row-1'},
      items: [
        {
          key: propertyPaths.punctureWoundDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Hours)"
              value={getQuoteFieldValue<number>(propertyPaths.punctureWoundDetails.incurralPeriod)}
              disabled
              id={propertyPaths.punctureWoundDetails.incurralPeriod}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.punctureWoundDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              disabled
              checked={getQuoteFieldValue<boolean>(propertyPaths.punctureWoundDetails.customizeBenefitAmount)}
              id={propertyPaths.punctureWoundDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'puncture-wound-row-2'},
      items: [
        {
          key: propertyPaths.punctureWoundDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              adornment="money"
              value={formatCurrencyValue(getQuoteFieldValue<number>(propertyPaths.punctureWoundDetails.benefitAmount))}
              id={propertyPaths.punctureWoundDetails.benefitAmount}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.punctureWoundDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`ACCPunctureWoundBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(propertyPaths.punctureWoundDetails.maxBenefitNumber)}
              disabled
              id={propertyPaths.punctureWoundDetails.maxBenefitNumber}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'puncture-wound-row-3'},
      items: [
        {
          key: propertyPaths.punctureWoundDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={`ACCPunctureWoundBenefit.timePeriodCd`}
              label="Time Period"
              value={getQuoteFieldValue<string>(propertyPaths.punctureWoundDetails.timePeriodCd)}
              disabled
              id={propertyPaths.punctureWoundDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
